"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class provides routing services for the application.
 */
class RoutingServiceBase {
    constructor() {
        /* Nothing to do */
    }
    getCoordinatesFromPoints(points) {
        const coordinates = [];
        points.features.forEach((feature) => {
            coordinates.push(feature.geometry.coordinates);
        });
        return coordinates;
    }
}
exports.default = RoutingServiceBase;
//# sourceMappingURL=RoutingService.js.map